<script setup lang="ts">
/**
 * SiteFooter —— 全局页面 chrome 底部（F17，ADR-0017）。
 *
 * 视觉结构沿用 `project/index.html` / `detail.html` `.footer-qt` 背景与
 * ftlogo（logoft.png）。按甲方反馈，底部版权/友情链接文字条不再渲染；
 * footer 仅作为全站模板视觉收尾。
 *
 * **不读 store**：组件不消费 `SiteConfig`，保持首页 + 详情页共享且可独立
 * mount 测试。
 */
</script>

<template>
  <footer :class="$style.footer" data-testid="site-footer">
    <div :class="$style.inner">
      <div :class="$style.ftlogo">
        <img :class="$style.ftlogoImg" src="/template/logoft.png" alt="" />
      </div>
    </div>
  </footer>
</template>

<style module src="./SiteFooter.module.css"></style>
